module.exports = __webpack_public_path__ + "img/1114ba8.jpg";